import React from 'react';
import { NavLink } from 'react-router-dom';
import { Slide_title } from "../components/slide-title.js";
import { Category_Header } from "../components/category-header.js";
import Head_CateHead from './Head_CateHead.js';

export const Account_head = ({ title_ }) => {
  const roleID = Number(localStorage.getItem("RoleID"));

  const roleName = {
    0: "Admin",
    1: "Retailer",
    2: "Wholesaler",
    3: "Portal User",
    4: "VIP User",
    5: "Sale Agent",
  };

  const accountTitle = roleName[roleID]
    ? `My Account - ${roleName[roleID]}`
    : "My Account";

  return (
    <div>
      <div className="container account">
        <Slide_title
          title={accountTitle}
          className="account_page_title"
        />

        <p className="account_subtitle">
          {localStorage.getItem("FullName")},{" "}
          <span>{localStorage.getItem("Email")}</span>
        </p>

        <hr />

        <ul className="account_menu">
          <NavLink to="/current_orders" activeClassName="active">
            <li><button>Current Orders</button></li>
          </NavLink>

          <NavLink to="/order_list" activeClassName="active">
            <li><button>Completed Orders</button></li>
          </NavLink>

          <NavLink to="/account" activeClassName="active">
            <li><button>Account Info</button></li>
          </NavLink>

          <NavLink to="/wishlist" activeClassName="active">
            <li><button>Wishlist</button></li>
          </NavLink>
        </ul>

        <hr className="hr_set" />

        {title_ && (
          <Slide_title
            title={title_}
            className="account_detail_title"
          />
        )}
      </div>
    </div>
  );
};